module.exports = __webpack_public_path__ + "img/default-user.82e1deb8.png";